  <div class="b-drawer__step" [style.padding-top]="hasCloseButton ? '16px' : '0'">
    <span w-icon *ngIf="hasCloseButton" (click)="wClose.emit()">close</span>
    @if (title) {
      @switch (level) {
        @case (1) { <h1 class="b-drawer__title" [innerHTML]="title"></h1> }
        @case (2) { <h2 class="b-drawer__title" [innerHTML]="title"></h2> }
        @case (3) { <h3 class="b-drawer__title" [innerHTML]="title"></h3> }
        @case (5) { <h5 class="b-drawer__title" [innerHTML]="title"></h5> }
        @case (6) { <h6 class="b-drawer__title" [innerHTML]="title"></h6> }
        @default { <h4 class="b-drawer__title" [innerHTML]="title"></h4> }
      }
    }
    <div class="b-drawer__title-actions">
      <ng-content select="f-facet[name=actions],[facet-actions]"></ng-content>
    </div>
  </div>
  <ng-content></ng-content>

